import { useCallback, useEffect } from 'react'

type UseKeyboardNavigationProps = {
  hasPrev: boolean
  hasNext: boolean
  onPrev: () => void
  onNext: () => void
}

export const useKeyboardNavigation = ({
  hasPrev,
  hasNext,
  onPrev,
  onNext
}: UseKeyboardNavigationProps) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const target = event.target as HTMLElement
      const isInputElement =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable

      if (isInputElement) {
        return
      }

      if (event.key === 'ArrowLeft' && hasPrev) {
        event.preventDefault()
        onPrev()
      } else if (event.key === 'ArrowRight' && hasNext) {
        event.preventDefault()
        onNext()
      }
    },
    [hasPrev, hasNext, onPrev, onNext]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}
